
import React, { FC } from "react";

import toast from "react-hot-toast";
import { CloseIcon } from "./icons";

interface Props {
  t: any;
  status: string;
  message: string;

}

const Notify: FC<Props> = ({
  t,
  status,
  message,
}) => {

  let color = '' 
  
  switch(status){
    case 'success': color= 'bg-green-600'; break;
    case 'warning': color= 'bg-orange-400'; break;
    case 'error': color= 'bg-red-600'; break;
    case 'info': color= 'bg-sky-600'; break;
    default: color= 'bg-gray-500'; break;
  }
  


  return (
    <div
    className={`${
      t.visible ? 'animate-enter' : 'animate-leave'
    } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
  >
    <div className={`w-2 ${color} rounded-l-lg`}></div>
    <div className="flex-1 w-0 p-4">
    
      <div className="flex items-start">
    
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium text-gray-900">
            {status}
          </p>
          <p className="mt-1 text-sm text-gray-500">
           {message}
          </p>
        </div>
      </div>
    </div>
    <div className="flex border-l border-gray-200">
      <button
        onClick={() => toast.dismiss(t.id)}
        className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      >
        <CloseIcon/>
      </button>
    </div>
  </div>
  );
};

export default Notify;
